import { useMutation, useQuery } from "@tanstack/react-query";
import axios from "axios";
import { IQueryParams } from "queries";
import helpers from "helpers/index";
import { TypedProduct } from "interface/product.model";
import queryClient from 'queries';

/**
*   Interface/model file auto generate for Setting Group
*   Interface for back-end
*   Model for front-end.
*   They are the same!
*/

export interface TypedProduct_to_brand {
    id?: string;
    product_id?: string;
    brand_id?: string;
    createdAt?: string;

    product?: TypedProduct
    product_to_brand_order?: number;
    pin_to_top?: number;
}

type IQuery = TypedProduct_to_brand & IQueryParams;

/*
* List of all app
*/
export function useGetProductToBrands(object: IQuery) {
    const EndURL = helpers.buildEndUrl(object);
    return useQuery({
        queryKey: ["product_to_brand/fetch_entity_list"],
        queryFn: () => axios.get<TypedProduct_to_brand[]>(`/product_to_brand${EndURL}`).then(response => {
            let { data, headers } = response;
            return {
                entities: data,
                totalItems: Number(headers['x-total-count'] || 0)
            }
        }),
        retry: 1,
        refetchOnWindowFocus: false,
        enabled: true,
    });
}

export function useGetProductToBrand(app_id: string) {
    return useQuery({
        queryKey: ['product_to_brand/fetch_entity'],
        queryFn: () => axios.get<TypedProduct_to_brand>(`/product_to_brand/${app_id}`).then((response) => response.data),
        retry: 1,
        refetchOnWindowFocus: false,
        // enabled: false,
    });
}

export function useCreateProductToBrand() {
    return useMutation({
        mutationKey: ['product_to_brand/create_entity'],
        mutationFn: (entity: TypedProduct_to_brand) => axios.post<TypedProduct_to_brand>(`/product_to_brand`, helpers.cleanEntity(entity)).then(response => response.data),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['product_to_brand/fetch_entity_list'] });
        }
    });
}

export function useDeleteProductToBrand() {
    return useMutation({
        mutationKey: ['product_to_brand/delete_entity'],
        mutationFn: ({ brand_id, product_id }: { brand_id: string, product_id: string }) => axios.delete<any>(`/product_to_brand/bulk_delete`, {
            data: { brand_id, product_id }
        }),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ['product_to_brand/fetch_entity_list'] });
        }

    });
}


export function usePinProductToTopBrand() {
  return useMutation({
    mutationKey: ['product_to_brand/pin_to_top'],
    mutationFn: (id: string) => axios.patch<any>(`/product_to_brand/pin_to_top/${id}`),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['product_to_brand/fetch_entity_list'] });
    }
  });
}
export function useRemovePinProductToTopBrand() {
  return useMutation({
    mutationKey: ['product_to_brand/pin_to_top'],
    mutationFn: (id: string) => axios.delete<any>(`/product_to_brand/pin_to_top/${id}`),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['product_to_brand/fetch_entity_list'] });
    }
  });
}


export function useBatchReorder() {
  return useMutation({
    mutationKey: ['product_to_brand/batch_reorder'],
    mutationFn: (reorderData: any) => axios.patch<any>(`/product_to_brand/batch_reorder`, helpers.cleanEntity(reorderData))
  });
}
